import Vue from "vue";
import { Ctor } from "vue-breakpoint-component";
import * as stringFilters from "./filters/string/index";

class Faset {
	get VERSION() {
		return "0.0.1";
	}

	constructor() {
		this._breakpoint;
		this._showAt;
		this._hideAt;
		this._eventbus;
		this._filters;

		this._breakpointConfig = {
			debounceTime: 50,
			experimental: false,
			breakpoints: {
				small: "(max-width: 767px)",
				medium: "(min-width: 768px)",
				large: "(min-width: 1024px)",
				xlarge: null
			}
		};

		this.init();
	}

	init() {
		this.registerBreakpoints();
		this.registerEventBus();
		this.registerFilters();
	}

	registerBreakpoints() {
		let components = { ...new Ctor(Vue, this._breakpointConfig) };
		this._breakpoint = components.VBreakpoint;
		this._showAt = components.VShowAt;
		this._hideAt = components.VHideAt;
	}

	registerEventBus() {
		this._eventbus = new Vue();
	}

	registerFilters() {
		this._filters = {
			install: function (Vue) {
				Object.entries(stringFilters).forEach(([key, value]) => {
					//console.log(`${key}: ${value}`);
					Vue.filter(key, value);
				});
			}
		};
	}
}

let faset = new Faset();

export const VBreakpoint = faset._breakpoint;
export const VShowAt = faset._showAt;
export const VHideAt = faset._hideAt;
export const EventBus = faset._eventbus;
export const filters = faset._filters;
export { default as plugins } from "./plugins/index";
export { default as mixins } from "./mixins/index";
export { Model } from "vue-breakpoint-component";
export { bounds, anchorOffset, target } from "./directives";

export default faset;

window.Faset = faset;
